import { web } from "./middleware";

export const UserProfileApi = {
  getProfile: () => web({ url: "/user/profile", method: "GET" }),
  updateTimeZOne: (payload) =>
    web({ url: "/user/update/time-zone", method: "PUT", data: payload }),
};

export default UserProfileApi;
